import React from "react";
import { SliceZone } from "@prismicio/react";
import Seo from "../components/molecules/Seo";
import { graphql } from "gatsby";
import styled from "styled-components";
import Container from "../components/atoms/Container";
import Pagination from "../components/organisms/Pagination";

import { PrismicRichText } from "@prismicio/react";
import SliceQuotePerspective from "../components/organisms/slices/SliceQuotePerspective";
import SliceImagePerspective from "../components/organisms/slices/SliceImagePerspective";
import SliceTextBlockPerspective from "../components/organisms/slices/SliceTextBlockPerspective";
import SliceTwoImage from "../components/organisms/slices/SliceTwoImage";
import SliceTextBlockImage from "../components/organisms/slices/SliceTextBlockImage";

import { withPrismicPreview } from "gatsby-plugin-prismic-previews";

const Holder = styled.article`
  background: #d7fffd;
`;

const Title = styled.div`
  background: black;
  padding: 0 0 1rem;

  .strategy {
    font-family: "Universal Sans";
    color: #707070;
  }

  h1 {
    ${(props) => props.theme.fluidType(13)}
    line-height: 1.0;
    font-family: "GT Flexa", sans-serif;
    font-weight: normal;
    color: #ff00ff;
    margin: 0;
  }

  h2 {
    ${(props) => props.theme.fluidType(13)}
    line-height: 1.0;
    font-family: "GT Flexa", sans-serif;
    font-weight: 300;
    margin: 0;
  }

  .author {
    font-family: "GT Flexa";
    font-weight: 300;
    color: #00ffce;
    ${(props) => props.theme.fluidType(1)}
  }

  @media (${(props) => props.theme.breakpoints.xs}) {
    h1,
    h2 {
      ${(props) => props.theme.fluidType(8)}
    }
  }

  @media (${(props) => props.theme.breakpoints.md}) {
    h1,
    h2 {
      ${(props) => props.theme.fluidType(5.4)}
    }
  }
`;

const HeroImage = styled.div`
  width: 100vw;
  height: auto;
  img {
    width: 100vw;
    height: auto;
    object-fit: cover;
  }

`;

const VideoHero = styled.div`
  position: relative;
  width: 100vw;
  min-height: 90svh;
  overflow: hidden;


  .library-video {
      position: absolute;
      z-index: 0;
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
  }

`;

const ArticleHolder = styled.div`
  padding: 1rem 0 10rem;
`;

const Strategies = styled.div`
  display: flex;

  ul {
    padding: 0;
    list-style-type: none;
    color: #707070;
    font-weight: bold;
    ${(props) => props.theme.fluidType(-3)}
    display: flex;
    align-items: center;
    text-transform: uppercase;
  }

  li:not(:last-child)::after {
    content: "";
    display: inline-block;
    width: 1px;
    height: 0.5rem;
    background-color: #707070;
    margin: 0 0.5rem;
    transform: translateY(0.05rem);
  }
`;

function PerspectivesArticlePage({ data, pageContext }) {
  const slices = data.prismicPerspective.data.body;
  const { title, strategy, description, author, hero_image, hero_video } =
    data.prismicPerspective.data;


  return (
    <Holder>
      <Seo title="PerspectivesArticlePage" />
      <Title>
        <Container>
          <Strategies>
            <PrismicRichText field={strategy.richText} />
          </Strategies>
          <PrismicRichText field={title.richText} />
          <PrismicRichText field={description.richText} />
          <p className="author">{author.text}</p>
        </Container>
      </Title>
        {
          hero_image.url !== null && hero_video?.url === null &&  (
            <HeroImage>
            <img src={hero_image?.url || undefined} alt={hero_image?.alt || undefined} />      
            </HeroImage>)
        }
        {
          hero_video?.url !== null && 
          <VideoHero>
          <video
              className="library-video"
              autoPlay
              loop
              muted
              playsInline
              poster={hero_image?.url || undefined}
            >
              <source
                src={hero_video?.url || undefined}
                type="video/mp4"
              />
            </video>
            </VideoHero>
        }
        
      <Container>
        <ArticleHolder>
          <SliceZone
            slices={slices}
            components={{
              image: SliceImagePerspective,
              quote: SliceQuotePerspective,
              text_block: SliceTextBlockPerspective,
              text_block_image: SliceTextBlockImage,
              two_image: SliceTwoImage,
            }}
          />
        </ArticleHolder>
        <Pagination next={pageContext.previous} prev={pageContext.next} />
      </Container>
    </Holder>
  );
}

export default withPrismicPreview(PerspectivesArticlePage);

export const query = graphql`
  query ($id: String) {
    prismicPerspective(id: { eq: $id }) {
      uid
      data {
        body {
          ... on PrismicPerspectiveDataBodyImage {
            ...SliceImagePerspective
          }
          ... on PrismicPerspectiveDataBodyTextBlock {
            ...SliceTextBlockPerspective
          }
          ... on PrismicPerspectiveDataBodyTextBlockImage {
            ...SliceTextBlockImage
          }
          ... on PrismicPerspectiveDataBodyTwoImage {
            ...SliceTwoImage
          }
          ... on PrismicPerspectiveDataBodyQuote {
            ...SliceQuotePerspective
          }
        }
        title {
          text
          richText
        }
        strategy {
          richText
        }
        description {
          text
          richText
        }
        author {
          text
        }
        hero_image {
          url
        }
        hero_video {
          url
        }
      }
    }
  }
`;

